import { SelectFieldGroupCombinedProps } from './types';

const usePresenter = (props: SelectFieldGroupCombinedProps): SelectFieldGroupCombinedProps => {
  return props;
};

export default usePresenter;
